/**
 * Generic file and image utility helpers.
 */

/**
 * Returns true if the file's MIME type indicates an image.
 */
export function isImageFile(file: File): boolean {
  return file.type.startsWith('image/');
}

/**
 * Resolves with the natural pixel dimensions of an image at the given object URL.
 * Rejects if the image fails to load.
 */
export function loadImageDimensions(src: string): Promise<{ width: number; height: number }> {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = () => resolve({ width: img.naturalWidth, height: img.naturalHeight });
    img.onerror = reject;
    img.src = src;
  });
}
